import { addItemToCollection } from "directus/src/operations";

export async function createHoliday({ item }) {
  try {
    const data = await addItemToCollection("holidays", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
